import { BaseElementDrawer } from '../../core/base/BaseElementDrawer';
import { GameApplicationType } from '../../core/enums';
import { BigWinMobilePopup } from './drawers/BigWinMobilePopup';
import { BigWinWebPopup } from './drawers/BigWinWebPopup';
import { BigWinLandscapePopup } from './drawers/BigWinLandscapePopup';

class BigWinPopupDrawer extends BaseElementDrawer {
  execute({ root }) {
    root.removeChildren();
    this.application.execute({ root });
  }
}

export const bigWinPopup = new BigWinPopupDrawer({
  [GameApplicationType.mobile]: new BigWinMobilePopup(),
  [GameApplicationType.web]: new BigWinWebPopup(),
  [GameApplicationType.landscape]: new BigWinLandscapePopup(),
});
